import { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import useGetQuery from '_api/queries/useGetQuery';
import { AccountType, ApiResponseError } from '_api/types';
import { usePermission } from 'utils/hooks/ctx-hooks';

const usePermittedQuery = <T>(
  authorized: AccountType[] = [],
  getEndpoint: () => string,
  requestOptions: object,
  queryKey: QueryKey,
  queryOptions: Omit<UseQueryOptions<T, ApiResponseError>, 'queryKey' | 'queryFn'>,
) => {
  const { permission } = usePermission();
  return useGetQuery(getEndpoint, requestOptions, queryKey, {
    ...queryOptions,
    enabled:
      permission && authorized.includes(permission)
        ? queryOptions?.enabled || true
        : false,
  });
};

export default usePermittedQuery;
